import {UPDATE_MIGRATIONS_LIST, SHOW_ALL_THEMIS_MIGRATIONS, SHOW_ALL_CPPRO_MIGRATIONS, SHOW_ALL_SPREADSHEET_MIGRATIONS} from '../../action.types'
import lodash from 'lodash'
import moment from 'moment'
const initialState = {
    themis: {
        all: [],
        filtered: []
    },
    cppro: {
        all: [],
        filtered: []
    },
    spreadsheet: {
        all: [],
        filtered: []
    }
}

const filterByOrigin = origin => migration => migration.origin == origin

const _update = (state, migrationsList) => {
    const orderedList = lodash.orderBy(migrationsList, migration => moment(migration.start), 'desc')
    const themisMigrations = orderedList.filter(filterByOrigin("THEMIS"))
    const cpproMigrations = orderedList.filter(filterByOrigin("CPPRO"))
    const spreadsheetMigrations = orderedList.filter(filterByOrigin("SPREADSHEET"))
    return {
        ...state,
        themis: {
            all: themisMigrations,
            filtered: themisMigrations.slice(0, 5)
        },
        cppro: {
            all: cpproMigrations,
            filtered: cpproMigrations.slice(0, 5)
        },
        spreadsheet: {
            all: spreadsheetMigrations,
            filtered: spreadsheetMigrations.slice(0, 5)
        }
    }
}

const _showAllThemis = state => ({
    ...state,
    themis: {
        ...state.themis,
        filtered: state.themis.all
    }
})

const _showAllCppro = state => ({
    ...state,
    cppro: {
        ...state.cppro,
        filtered: state.cppro.all
    }
})

const _showAllSpreadsheet = state => ({
    ...state,
    spreadsheet: {
        ...state.spreadsheet,
        filtered: state.spreadsheet.all
    }
})

export default (state = initialState, action) => {
    switch(action.type){
        case UPDATE_MIGRATIONS_LIST:
            return _update(state, action.payload)
        case SHOW_ALL_THEMIS_MIGRATIONS:
            return _showAllThemis(state)
        case SHOW_ALL_CPPRO_MIGRATIONS:
            return _showAllCppro(state)
        case SHOW_ALL_SPREADSHEET_MIGRATIONS:
            return _showAllSpreadsheet(state)
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/migrations-list/migrations.list.reducer.js